var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.src},on:{"click":_vm.switchImage}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullscreen),expression:"fullscreen"}],staticClass:"overlay",on:{"click":_vm.switchImage}},[_c('img',{attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }